'use client';

import FsSection1 from '@enlighten/landing/dist/fs-roof/@section1';

export default function Section1() {
	return (
		<FsSection1
			onClick={() => {
				window.open(`https://support.enlighten.kr/hc/ko/requests/new?ticket_form_id=21052751044633`, '_blank');
			}}
		/>
	);
}
